import {
  dispatchHydrateUI,
  dispatchResetSquareUI,
  dispatchResetUI,
  dispatchResetUIWithCache,
  dispatchSaveUI,
} from "..";
import { questionsUtils } from "../../..";
import { store } from "../../../store";
import { logger } from "@services/workers/helpers";
import { fixDate } from "@utils/general";
import ObjectsOperations from "@utils/objects/operations";
import StorageUtils from "@services/storage";
import { TemplateUIObject } from "@services/storage/storeTemplate";
import { uiSelector, storeName, templateState } from "../slice";

const namespace = "UIReducer";

// Reusable function to handle state changes
const handleStateChange = (actionName: string, action: () => void, additionalLogInfo = "", additionalAction?: () => void) => {
  logger.debug(`${namespace}->${actionName}`, additionalLogInfo);
  action();
  if (additionalAction) additionalAction();
  dispatchSaveUI();
}

// Hydrate UI Reducer
export const hydrateUIReducer = async () => {
  const newState = ObjectsOperations.typeSafeStructuredClone<TemplateUIObject>(templateState);
  for (const key in newState) {
    const value = fixDate(StorageUtils.getFromStorage({ type: "local", store: storeName, key }));
    if (value) {
      newState[key as keyof typeof newState] = value as never;
    }
  }
  if (newState.ProblemComboJob) {
    questionsUtils.loadQuestions(newState.ProblemComboJob.jobTypeCode);
  }
  handleStateChange(hydrateUIReducer.name, () => dispatchHydrateUI(newState), "Data loaded");
};

// Reset UI Reducer
export const resetUIReducer = (exceptions?: string[]) => {
  const exceptionsObj = handleExceptions(exceptions);
  handleStateChange(resetUIReducer.name, () => dispatchResetUI(exceptionsObj), "Resetting state");
};

export const resetSquareUIReducer = () => {
  handleStateChange(resetSquareUIReducer.name, dispatchResetSquareUI, "Resetting square UI");
};

export const resetUIReducerWithCache = (exceptions?: string[]) => {
  const exceptionsObj = handleExceptions(exceptions);
  handleStateChange(resetUIReducerWithCache.name, () => dispatchResetUIWithCache(exceptionsObj), "Resetting state with cache");
};

export const importUIReducer = (ui: TemplateUIObject) => {
  // Preserve CallMeBacksQueue
  const uiOrg = uiSelector(store.getState());
  ui.CallMeBacksQueue = uiOrg.CallMeBacksQueue;
  handleStateChange(importUIReducer.name, () => dispatchHydrateUI(ui), "Importing state");
};

// Handle exceptions for reset reducers
const handleExceptions = (exceptions?: string[]) => {
  const exceptionsObj: any = {};
  if (exceptions) {
    const ui = store.getState().ui;
    for (const key of exceptions) {
      exceptionsObj[key] = ObjectsOperations.typeSafeStructuredClone(ui[key as keyof typeof ui]);
    }
  }
  return exceptionsObj;
}
